<template>
  <div>

    <div class="bar">
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item" @click="orderStatus.show = true">状态：{{ orderStatuslist }}<span
            class="caret"></span></div>
      </div>
    </div>

    <van-search v-model.trim="wechatNumber" class="search-bar" shape="round" show-action placeholder="搜索微信号"
                @search="onSearch" @cancel="onSearch" @clear="onSearch">
      <div slot="action" @click="onSearch">
        搜索
      </div>
    </van-search>

    <van-list
        class="orderlist"
        v-model="loading"
        :finished="listFinished"
        @load="loadData"
        finished-text="没有更多了">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div v-if="item.status != 0" class="dataBox">
          <div class="wechat">微信号： {{ item.wechatNumber }}</div>
        </div>
        <div v-if="item.sex == 1">要求性别： 男</div>
        <div v-if="item.sex == 2">要求性别： 女</div>
        <div>下单时间： {{ formatDate(item.createTime, 'MM-DD HH:mm') }}</div>
        <div v-if="item.confirmTime">抢单时间： {{ formatDate(item.confirmTime, 'MM-DD HH:mm') }}</div>
        <div v-if="item.finishTime">完成时间： {{ formatDate(item.finishTime, 'MM-DD HH:mm') }}</div>
        <div class="tags">
          <div>服务标签：</div>
          <div v-for="(item, index) in item.tags" :key="index" class="tagsItem">
            {{ item }}
          </div>
        </div>
        <div>
            <div class="label">店员截图：</div>
            <div class="screenshot">
              <div class="imgStyle" v-for="(screenShot,i) in item.screenShotList" :key="i" @click="imgClick(item.screenShotList,i)">
                <img :src="screenShot" class="screenshotImg">
              </div>
            </div>
        </div>
        <div class="status">
          <van-tag v-if="item.status == 1" plain type="success">已完成</van-tag>
          <van-tag v-if="item.status == 0" plain type="warning">待接单</van-tag>
          <van-tag v-if="item.status == 2" plain type="primary">服务中</van-tag>
        </div>

        <div class="statusBtn" @click.stop="confirmFinish(item.id)" v-if="item.status == 2">
          确认完成
        </div>
        <div class="statusBtn" @click.stop="statusBtn(item.id, 2)" v-if="item.status == 0">
          确认接单
        </div>
      </div>
    </van-list>
    <van-dialog v-model="confirmFinishModalVisible" title="确认完成"
                show-cancel-button
                confirm-button-text="确认"
                :before-close="onConfirmFinish">
      <van-cell-group inset>
          <div style="font-size: 14px;color: #646566;margin-top: 10px">
            上传截图
          </div>
          <upload-photo :imgArr="[]" :imgAmount="4" @uploadimg="onImageUpload" titleText="上传截图"></upload-photo>
      </van-cell-group>
    </van-dialog>
    <van-action-sheet
        v-model="orderStatus.show"
        :actions="orderStatus.actions"
        cancel-text="取消"
        @select="onClerkStatus"/>

  </div>
</template>

<script>
import Vue from 'vue';
import {ActionSheet, Dialog, List, CellGroup, Cell, Tag, Toast, Search, ImagePreview} from 'vant';
import {getFirstOrderListForClerk, updateFirstOrderStatusForClerk} from "@/api/firstOrder";
import moment from "moment";
import UploadPhoto from "@/views/uploadPhoto";

Vue.use(ActionSheet)
    .use(Dialog)
    .use(List)
    .use(CellGroup)
    .use(Cell)
    .use(Tag)
    .use(Toast)
    .use(Search)


export default {
  name: "list",
  components: {UploadPhoto},
  data() {
    return {
      list: null,
      status: null,
      pageNo: 1,
      pageSize: 10,
      inputWechatNumber: null,
      wechatNumber: null,
      loading: false,
      listFinished: false,
      orderStatus: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '待接单', value: 0},
          {name: '已完成', value: 1},
          {name: '服务中', value: 2},
        ]
      },
      orderId: null,
      imageArray: [],
      confirmFinishModalVisible: false
    }
  },

  computed: {
    orderStatuslist() {
      if (this.status == 0) {
        return '待接单'
      }
      if (this.status == 1) {
        return '已完成'
      }
      if (this.status == 2) {
        return '服务中'
      }
      return '全部'
    },
  },

  methods: {
    imgClick(screenShotList,i) {
      ImagePreview({
        images: screenShotList,
        startPosition: i,
      })
    },
    onConfirmFinish(action,done){
      if(action==='cancel'){
        return done();
      }
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      updateFirstOrderStatusForClerk(
          1,
          this.orderId,
          JSON.stringify(this.imageArray)
      ).then(res => {
        Toast.clear()
        let data = res.data
        if (data.code == 0) {
          this.loadData(true)
          done()
          return Toast('修改成功');
        } else {
          done(false)
          Dialog.alert({
            title: '修改失败',
            message: data.msg,
          })
        }

      })
    },
    onImageUpload(imageArr){
      this.imageArray = imageArr.map(elem=>{return {base: elem.content}})
    },
    onSearch() {
      this.inputWechatNumber == null
      this.loadData(true)
    },

    statusBtn(id, status) {
      let msg = status == 2 ? '确认进行服务吗' : '确认服务完成吗'
      Dialog.confirm({
        title: msg,
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        updateFirstOrderStatusForClerk(
            status,
            id,
        ).then(res => {
          Toast.clear()
          let data = res.data
          if (data.code == 0) {
            this.loadData(true)
            return Toast('修改成功');
          } else {
            Dialog.alert({
              title: '修改失败',
              message: data.msg,
            })
          }
        })
      });
    },
    confirmFinish(orderId){
      this.orderId = orderId
      this.imageArray = []
      this.confirmFinishModalVisible = true
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    onClerkStatus(item) {
      this.status = item.value
      this.orderStatus.show = false
      this.loadData(true)
    },

    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getFirstOrderListForClerk(
          this.inputWechatNumber||this.wechatNumber,
          this.status,
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    }
  },


  mounted() {
    if (this.$route.query.wechatNumber) {
      this.status = null
      this.inputWechatNumber = this.$route.query.wechatNumber
    }
  }
}
</script>

<style lang="less" scoped>

.bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 8px 0;
  background: #fff;

  .van-search {
    background: none;
    border-radius: 100px;
    border: 1px solid #999;
    height: 33px;
    width: 130px;
    padding: 0;

    .van-cell {
      padding: 0;
    }

    .van-icon {
      //display: none;
    }
  }
}

.orderlist {

  .list-item {
    padding: 10px 20px;
    color: #000;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      right: 16px;
      left: 16px;
      bottom: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(.8);
    }

    .dataBox {
      display: flex;

      .wechat {
        margin-right: 30px;
      }
    }

    .tags {
      display: flex;

      .tagsItem {
        margin: 0 6px;
      }
    }

    .status {
      position: absolute;
      top: 20px;
      right: 33px;
      border-radius: 8px;
    }

    .statusBtn {
      position: absolute;
      top: 45px;
      right: 20px;
      padding: 2px 8px;
      background: #07c160;
      color: #fff;
    }
    .imgStyle{
      margin-left: 10px;
      flex: 0 0 15%;
      height: 0;
      padding-bottom: 15%;
      overflow: hidden;
      position: relative;
    }
    .screenshot{
      width: 100%;
      display: flex;
      align-content: flex-start;
      flex-flow: row wrap;
    }
    .screenshotImg{
      width: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}


</style>
